<template>
  <div class="kviz">
    <form
      action="#"
      @submit="formPost"
      method="post"
      novalidate="true"
      enctype="multipart/form-data"
      autocomplete="off"
      id="kvizmvuk"
    >
      <div
        v-for="(item, index) in kerdesek"
        v-bind:key="index"
        v-show="index + 1 === $store.state.currentStep"
        class="kerdesek"
      >
        <div class="kerdes">
          <span class="number">{{index+1}}.</span> {{item.kerdes}}
        </div>
        <div
          v-if="item.bevezeto"
          class="kbevezeto"
        >
          {{item.bevezeto}}
        </div>
        <div class="valaszcont">
          <div
            class="valasz"
            v-for="(vitem, index2) in kerdesek[index].valasz"
            v-bind:key="index2"
          >
            <input
              type="radio"
              :name="'kerdes'+(index+1)"
              v-bind:value="index2"
              :id="'k'+(index+1)+'opt'+index2"
            >
            <label
              :for="'k'+(index+1)+'opt'+index2"
              v-on:click="choice"
            >
              <div class="lettercont">
                {{index2}}
              </div>
              <div class="textcont">
                {{vitem.text}}
              </div>
            </label>
          </div>
        </div>
      </div>
      <div
        class="last"
        v-show="$store.state.currentStep === $store.state.maxStep"
      >
        <div class="urlaphead">
          <div class="title">
            Kérjük, töltsd ki az alábbi mezőket!
          </div>
        </div>
        <div class="formfield">
          <input
            v-model="nev"
            type="text"
            name="nev"
            id="nev"
            placeholder="név*"
          >
          <div
            v-if="errors.nev"
            class="error"
          >
            {{errors.nev}}
          </div>
        </div>
        <div class="formfield">
          <vue-mask
            v-model="szuletes"
            v-on:keydown="restrictions($event)"
            mask="9999.99.99"
            name="szuletes"
            id="szuletes"
            :raw="false"
            :options="szuloptions"
          >
          </vue-mask>
          <div
            v-if="errors.szuletes1"
            class="error"
          >
            {{errors.szuletes1}}
          </div>
          <div
            v-if="errors.szuletes2"
            class="error"
          >
            {{errors.szuletes2}}
          </div>
        </div>
        <div class="formfield">
          <input
            v-model="email"
            type="email"
            name="email"
            id="email"
            placeholder="e-mail*"
          >
          <div
            v-if="errors.mail1"
            class="error"
          >
            {{errors.mail1}}
          </div>
          <div
            v-if="errors.mail2"
            class="error"
          >
            {{errors.mail2}}
          </div>
          <div
            v-if="errors.mail3"
            class="error"
          >
            {{errors.mail3}}
          </div>
          <div
            v-if="errors.mail4"
            class="error"
          >
            {{errors.mail4}}
          </div>
        </div>
        <div class="formfield">
          <vue-mask
            v-model="telefon"
            mask="99-99-999-9999"
            name="telefon"
            id="telefon"
            :raw="false"
            :options="teloptions"
          >
          </vue-mask>
          <div
            v-if="errors.telefon1"
            class="error"
          >
            {{errors.telefon1}}
          </div>
          <div
            v-if="errors.telefon2"
            class="error"
          >
            {{errors.telefon2}}
          </div>
        </div>
        <div class="formfield">
          <vue-mask
            v-model="irsz"
            name="irsz"
            id="irsz"
            v-on:keydown="restrictions($event)"
            mask="9999"
            :raw="false"
            :options="irszoptions"
          >
          </vue-mask>
          <div
            v-if="errors.irsz1"
            class="error"
          >
            {{errors.irsz1}}
          </div>
          <div
            v-if="errors.irsz2"
            class="error"
          >
            {{errors.irsz2}}
          </div>
        </div>
        <div class="jogicont">
          <div class="magyarazat">
            A csillaggal jelölt mezők kitöltése kötelező.
          </div>
          <input
            type="checkbox"
            name="nyilatkozat"
            id="nyilatkozat"
            v-model="nyilatkozat"
          >
          <label
            for="nyilatkozat"
            class="nylabel"
          >
            <p><span
                v-if="errors.nyilatkozat"
                class="error"
              >{{errors.nyilatkozat}}</span> Az <a
                href="https://forbes.hu/documents/altalanos_adatkezelesi_tajekoztato_Forbeshu.pdf"
                target="_blank"
              >adatkezelési szabályzatot</a> elolvastam és elfogadom.</p>
          </label>
          <input
            type="checkbox"
            name="hozzajarulas2"
            id="hozzajarulas2"
            v-model="hozzajarulas2"
          >
          <label
            for="hozzajarulas2"
            class="hozzajarulas2label"
          >
            <p><span
                v-if="errors.hozzajarulas2"
                class="error"
              >{{errors.hozzajarulas2}} </span>Hozzájárulok ahhoz, hogy az adataimat az Allianz Hungária Zrt. a jövőben saját marketingtevékenysége, termékei ismertetése, (személyre szabott) ajánlatok elkészítése és részemre történő megküldése céljából felhasználhatja.</p>
          </label>
        </div>
        <input
          id="submission"
          type="submit"
          value="Eredmény"
        >
      </div>
    </form>
    <div class="thankyoupage">
      <div class="thanktitle">Kedves {{nev}}!</div>
      <div class="thanksubtext">Köszönjük, hogy kitöltötted a kvízt. Az értékelést a megadott e-mail címre küldjük.</div>
      <div class="btn">
        <a
          href="https://forbes.hu"
          title="forbes.hu"
        >Tovább a <img
            alt="Forbes"
            class="nxtforbes"
            src="../assets/images/forbes-head.svg"
          >.hu-ra</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import vueMask from 'vue-jquery-mask'

export default {
  name: 'Kform',
  components: {
    vueMask
  },
  data: () => {
    return {
      errors: {
      },
      nev: null,
      szuletes: null,
      szuloptions: {
        placeholder: 'születési dátum: 1980.01.01*'
      },
      email: null,
      telefon: null,
      teloptions: {
        placeholder: 'Mobilszám: 36-70-123-4567*'
      },
      irsz: null,
      irszoptions: {
        placeholder: 'irányítószám*'
      },
      nyilatkozat: null,
      hozzajarulas2: null,
      kerdesek: [
        {
          kerdes: 'Gondoltál már arra, hogy takarékoskodj nyugdíjas éveidre?',
          valasz: {
            a: {
              text: 'Nem, soha, majd az állam gondoskodik rólam, ez a dolga.'
            },
            b: {
              text: 'Igen, én már fizetek valamilyen öngondoskodási formában. '
            },
            c: {
              text: 'A munkáltatóm fizet a járulékok mellett erre a célra.'
            },
            d: {
              text: 'A nyugdíjjárulék a fizetési cetlimen pont erre van kitalálva.'
            }
          }
        },
        {
          kerdes: 'Ha már takarékoskodás, szerinted milyen formában érdemes félretenni a nyugdíjas évekre?',
          valasz: {
            a: {
              text: 'Ingatlan.'
            },
            b: {
              text: 'Önkéntes nyugdíjpénztár.'
            },
            c: {
              text: 'Nyugdíjbiztosítás.'
            },
            d: {
              text: 'Állami nyugdíj.'
            }
          }
        },
        {
          kerdes: 'Na de mikor kellene elkezdeni?',
          valasz: {
            a: {
              text: 'Úgysem élem meg a nyugdíjas éveket, nem érdemes félretenni.'
            },
            b: {
              text: 'Az első gyerek érkezésekor érdemes elkezdeni az öngondoskodást.'
            },
            c: {
              text: '30 éves kor körül biztosan eljön az ideje a takarékoskodásnak.'
            },
            d: {
              text: 'Már az első munkahelyen érdemes olyan szerződést kötni, amely tartalmaz valamilyen kiegészítő nyugdíjbiztosítást.'
            }
          }
        },
        {
          kerdes: 'Mennyit érdemes öngondoskodásra fordítani havonta?',
          valasz: {
            a: {
              text: 'Ilyen fizetések mellett jó, ha egy sörre futja esténként.'
            },
            b: {
              text: 'Havonta 20 ezer forint lehet a megfelelő összeg.'
            },
            c: {
              text: 'Havonta 10 ezer forintot.'
            },
            d: {
              text: 'Havonta 40 ezer forint akkora összeg, ami az állami nyugdíjjal együtt már egy biztos megélhetést tesz lehetővé.'
            }
          }
        },
        {
          kerdes: 'Kire érdemes bízni az öngondoskodásra fordított pénzt?',
          valasz: {
            a: {
              text: 'Az állami nyugdíjrendszerre.'
            },
            b: {
              text: 'Egy jó nevű biztosító a legmegbízhatóbb partner.'
            },
            c: {
              text: 'A nyugdíjpénztárak erre vannak kitalálva.'
            },
            d: {
              text: 'Mindig bankban tartottam a pénzem, és ez a legbiztosabb befektetés szerintem.'
            }
          }
        },
        {
          kerdes: 'Szerinted érdemes lakásbiztosítást kötni?',
          valasz: {
            a: {
              text: 'Tök mindegy, még soha nem hallottam olyat, hogy mindent elloptak volna egy lakásból, az épülettel együtt.'
            },
            b: {
              text: 'A klímaváltozás már itt van, inkább egy biztosító fizesse ki a viharkáraimat, mint én.'
            },
            c: {
              text: 'Ha vigyázok az otthonomra, akkor ez csak felesleges pénzkidobás.'
            },
            d: {
              text: 'Nagyon fontos a számomra, hogy legyen biztosítás a lakásomon/házamon, mert bármi történhet.'
            }
          }
        },
        {
          kerdes: 'Szerinted érdemes-e időnként aktualizálni a lakásbiztosításodat?',
          valasz: {
            a: {
              text: 'Nem, mert akkor biztosan többet kell fizetnem.'
            },
            b: {
              text: 'Mondtam már, hogy egy lakást nem lehet ellopni, akármennyibe is kerül!'
            },
            c: {
              text: 'Ha nagyobb értékű ingóság kerül a lakásba, igen. Például egy új televízió, vagy a nagymama ékszerei.'
            },
            d: {
              text: 'Érdemes, mert most többe kerül egy lakást felépíteni vagy felújítani.'
            }
          }
        },
        {
          kerdes: 'Mire nyújt fedezetet egy lakásbiztosítás?',
          valasz: {
            a: {
              text: 'Betöréses lopás, rablás, természeti károk (vihar, jégverés).'
            },
            b: {
              text: 'Bármire, amire a biztosító kockázatot vállal.'
            },
            c: {
              text: 'Ahogy mondtam, nem lehet a lakást ellopni, a többit pedig majd én megoldom.'
            },
            d: {
              text: 'Akár én magam is kiválaszthatom a biztosító által javasolt csomagokból a nekem megfelelőt.'
            }
          }
        }
      ]
    }
  },
  methods: {
    thankYou () {
      document.querySelector('.thankyoupage').classList.add('show')
      document.querySelector('form').remove()
      this.$ga.page({
        title: 'Kitöltés köszönő',
        page: '/kviz',
        location: window.location.href
      })
    },
    nevValid () {
      if (!this.nev) {
        this.errors.nev = 'Kérlek add meg a neved!'
        return false
      }
      if (this.nev.length < 3) {
        this.errors.nev = 'Kérlek valós nevet adj meg!'
        return false
      }
      return true
    },
    szuletesValid () {
      if (!this.szuletes) {
        this.errors.szuletes1 = 'Kérlek add meg születési dátumod!'
        return false
      } else if (this.szuletes.length < 10 && this.szuletes.length > 0) {
        this.errors.szuletes2 = 'Kérlek valós dátumot adj meg!'
        return false
      } else if (this.szuletes.length === 10) {
        let szuletesnap = this.szuletes.split('.').map(Number)
        if (szuletesnap[0] > 2002 || szuletesnap[0] < 1900) {
          this.errors.szuletes2 = 'Kérlek valós dátumot adj meg!'
          return false
        }
        if (szuletesnap[1] > 12) {
          this.errors.szuletes2 = 'Kérlek valós dátumot adj meg!'
          return false
        }
        if (szuletesnap[2] > 31) {
          this.errors.szuletes2 = 'Kérlek valós dátumot adj meg!'
          return false
        }
      } return true
    },
    emailValid () {
      if (!this.email) {
        this.errors.mail1 = 'Kérlek add meg az e-mail címed!'
        return false
      } else if (!this.validEmail(this.email)) {
        this.errors.mail2 = 'Kérlek valós e-mail címet adj meg!'
        return false
      } return true
    },
    telefonValid () {
      if (!this.telefon) {
        this.errors.telefon1 = 'Kérlek add meg a mobilszámod!'
        return false
      } else if (this.telefon.length < 14 && this.telefon.length > 0) {
        this.errors.telefon2 = 'Kérlek valós mobilszámot adj meg!'
        return false
      }
      if (this.telefon.length === 14) {
        let telszamArr = this.telefon.split('-').map(Number)
        if ((telszamArr[0] !== 6) && (telszamArr[0] !== 36)) {
          this.errors.telefon2 = 'Kérlek valós mobilszámot adj meg!'
          return false
        } else if (telszamArr[1] !== 20 && telszamArr[1] !== 30 && telszamArr[1] !== 70 && telszamArr[1] !== 31) {
          this.errors.telefon2 = 'Kérlek valós mobilszámot adj meg!'
          return false
        }
      }
      return true
    },
    irszValid () {
      if (!this.irsz) {
        this.errors.irsz1 = 'Kérlek add meg az irányítószámodat!'
        return false
      } else if (this.irsz.length < 4 && this.irsz.length > 0) {
        this.errors.irsz2 = 'Kérlek valós irányítószámot adj meg!'
        return false
      } if (this.irsz.length === 4) {
        axios
          .get('./backend/ziphungary.json')
          .then((response) => {
            if (response.status === 200 && response.request.readyState === 4 && response.data.hasOwnProperty(this.irsz)) {
              return true
            } else {
              this.$set(this.errors, 'irsz2', 'Kérlek valós irányítószámot adj meg!')
              return false
            }
          })
          .catch((error) => {
            this.$set(this.errors, 'irsz2', error.response.data)
            return false
          })
      }
      return true
    },
    nyilatkozatValid () {
      if (!this.nyilatkozat) {
        this.errors.nyilatkozat = 'Kérlek fogadd el!'
        return false
      } return true
    },
    hozza2Valid () {
      if (!this.hozzajarulas2) {
        this.errors.hozzajarulas2 = 'Kérlek járulj hozzá!'
        return false
      } return true
    },
    checkForm () {
      this.errors = {}
      this.nevValid()
      this.szuletesValid()
      this.emailValid()
      this.telefonValid()
      this.irszValid()
      this.nyilatkozatValid()
      this.hozza1Valid()
      this.hozza2Valid()
      if (Object.keys(this.errors).length !== 0 && this.errors.constructor === Object) {
        setTimeout(() => {
          const errorArray = document.querySelectorAll('.error')
          errorArray[0].parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 500)
      }
      if (!this.nevValid() ||
        !this.szuletesValid() ||
        !this.emailValid() ||
        !this.telefonValid() ||
        !this.irszValid() ||
        !this.nyilatkozatValid() ||
        !this.hozza1Valid() ||
        !this.hozza2Valid()) {
        return false
      }
      return true
    },
    validEmail (email) {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (email.length < 8) {
        return false
      }
      return re.test(email)
    },
    formPost (event) {
      event.preventDefault()
      if (this.checkForm()/* && Object.keys(this.errors).length === 0 && this.errors.constructor === Object */) {
        const form = document.querySelector('form')
        let fdRaw = new FormData(form)
        let fdata = {}

        if (document.documentMode || /Edge/.test(navigator.userAgent)) {
          fdata.nev = this.nev
          fdata.szuletes = this.szuletes
          fdata.email = this.email
          fdata.telefon = this.telefon
          fdata.irsz = this.irsz
          fdata.nyilatkozat = this.nyilatkozat
          fdata.hozzajarulas2 = this.hozzajarulas2
          fdata.kerdes1 = document.querySelector('input[name="kerdes1"]:checked').value
          fdata.kerdes2 = document.querySelector('input[name="kerdes2"]:checked').value
          fdata.kerdes3 = document.querySelector('input[name="kerdes3"]:checked').value
          fdata.kerdes4 = document.querySelector('input[name="kerdes4"]:checked').value
          fdata.kerdes5 = document.querySelector('input[name="kerdes5"]:checked').value
          fdata.kerdes6 = document.querySelector('input[name="kerdes6"]:checked').value
          fdata.kerdes7 = document.querySelector('input[name="kerdes7"]:checked').value
          fdata.kerdes8 = document.querySelector('input[name="kerdes8"]:checked').value
        } else {
          fdRaw.forEach((value, key) => { fdata[key] = value })
        }

        let json = JSON.stringify(fdata)

        axios
          .post(
            './backend/process.php', // http://forbes-dev.hu/allianz3/backend/process.php
            json
          )
          .then((response) => {
            if (response.status === 201 && response.request.readyState === 4 && response.data.message6 === 'Sikeres mentés, rekord hozzáadva.') {
              this.thankYou()
            }
          })
          .catch((error) => {
            if (error.response.status === 503 && error.response.data.hasOwnProperty('message4')) {
              this.$set(this.errors, 'mail3', error.response.data.message4)
            }
            if (error.response.status === 503 && error.response.data.hasOwnProperty('message8')) {
              this.$set(this.errors, 'irsz2', error.response.data.message8)
            }
          })
          .finally(() => {
            // this runs in any case
          })
      }
    },
    ...mapActions([
      'decrement',
      'increment',
      'prevslide',
      'nextslide'
    ]),
    countQuestions () {
      this.$store.state.currentStep = 1
      this.$store.state.maxStep = this.kerdesek.length + 1
      this.stepBar()
      this.resetstep()
      document.querySelector('#kvizmvuk').reset()
    },
    moveBG () {
      this.bikeAnim()
      const WindowWidth = document.querySelector('body').clientWidth
      const bgIMG = document.querySelector('.backgroundimg')
      const stepSize = (bgIMG.scrollWidth - WindowWidth) / this.$store.state.bgMax
      bgIMG.setAttribute('style', 'transform: translateX(' + (stepSize * this.$store.state.bgCurrent) * -1 + 'px)')
    },
    stepBar () {
      const barinner = document.querySelector('.barinner')
      barinner.style.cssText = `flex-basis: ${this.$store.state.currentStep / (this.$store.state.maxStep - 1) * 100}%`
    },
    stepBack () {
      this.$store.dispatch('decrement')
      this.$store.dispatch('prevslide')
      this.stepBar()
      this.moveBG()
    },
    stepNext () {
      this.$store.dispatch('increment')
      this.$store.dispatch('nextslide')
      this.stepBar()
      this.moveBG()
      window.scrollTo(0, 0)
      this.$ga.page({
        title: `Kviz oldal: ${this.$store.state.currentStep}`,
        page: '/kviz',
        location: window.location.href
      })
    },
    resetstep () {
      this.$store.state.currentStep = 1
      this.$store.state.bgCurrent = 1
      this.moveBG()
    },
    choice (e) {
      e.target.parentElement.classList.add('chosen')
      const siblings = e.target.parentElement.parentElement.querySelectorAll('.valasz')
      for (let index = 0; index < siblings.length; index++) {
        const element = siblings[index]
        if (!element.classList.contains('chosen')) {
          element.classList.add('not')
          element.querySelector('input').disabled = true
        }
      }
      this.stepNext()
    },
    restrictions (e) {
      const key = e ? e.keyCode : e.which
      if (e.keyCode === 8 || e.keyCode === 46) {
        return true
      } if (key < 48 || key > 57) {
        e.preventDefault()
        return false
      }
      return true
    },
    bikeAnim () {
      const bike = document.querySelector('.fixedbike')
      bike.classList.toggle('anim')
      setTimeout(() => {
        bike.classList.toggle('anim')
      }, 750)
    }
  },
  mounted () {
    this.countQuestions()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kerdesek {
  margin: 0 auto;
  width: calc(100vw - 100px);
}
.kbevezeto {
  margin: 0 auto 15px auto;
  font-size: 18px;
}
.kbevezeto,
.kerdes {
  width: 70vw;
}
.kerdes {
  margin: 40px auto 35px auto;
}
.kerdes,
.title,
.thanktitle {
  font-family: "AllianzNeo-Bold", sans-serif;
  font-size: 32px;
}
.thanksubtext {
  font-size: 18px;
}
.valaszcont {
  width: calc(100% - 200px);
  display: grid;
  display: -ms-grid;
  grid-template-columns: 50% 50%;
  -ms-grid-columns: 50% 50%;
  grid-template-rows: auto auto;
  -ms-grid-rows: auto auto;
  grid-row-gap: 30px;
  grid-column-gap: 30px;
  justify-content: center;
  margin: 0 auto;
}
.valasz:nth-child(1) {
  grid-column: 1/2;
  -ms-grid-column: 1;
  grid-row: 1/2;
  -ms-grid-row: 1;
}
.valasz:nth-child(2) {
  grid-column: 1/2;
  -ms-grid-column: 1;
  grid-row: 2/3;
  -ms-grid-row: 2;
}
.valasz:nth-child(3) {
  grid-column: 2/3;
  -ms-grid-column: 2;
  grid-row: 1/2;
  -ms-grid-row: 1;
}
.valasz:nth-child(4) {
  grid-column: 2/3;
  -ms-grid-column: 2;
  grid-row: 2/3;
  -ms-grid-row: 2;
}
.valasz label {
  display: flex;
  justify-content: center;
  border-radius: 22px;
  background-color: #003781;
  box-shadow: 0px 0px 2px 0px #003781;
  flex-wrap: nowrap;
  font-family: "AllianzNeo-Bold", sans-serif;
}
.lettercont {
  color: #fff;
  flex-basis: 40px;
  align-self: center;
  text-align: center;
  text-transform: uppercase;
  font-size: 28px;
}
.textcont {
  border-radius: 22px;
  background-color: #fff;
  padding: 10px 14px;
  flex-basis: calc(100% - 40px);
  font-size: 15px;
}
.valasz input[type="radio"] {
  display: none;
}
.valasz.chosen,
.valasz.not {
  pointer-events: none;
  cursor: default;
}
.valasz label:hover {
  cursor: pointer;
}
.valasz label:hover,
.valasz.chosen label {
  background-color: #5b69d1;
  box-shadow: 0px 0px 2px 0px #5b69d1;
}
.valasz.not:hover label {
  background-color: #fff;
}
.valasz.not label {
  color: #666;
}
.last {
  display: grid;
  margin: 20px auto 0 auto;
  width: 65vw;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.last div:nth-child(2) {
  grid-column: 1/3;
}
.last a {
  color: #003781;
}
.urlaphead,
.magyarazat,
.jogicont,
#submission {
  grid-column: 1/3;
}
#submission {
  justify-self: center;
  border: none;
  padding: 15px 30px;
  font-size: 14px;
  margin-bottom: 20px;
  color: #fff;
  font-family: "AllianzNeo-Regular", sans-serif;
}
.last input {
  border-radius: 22px;
  border: 2px solid #325e9a;
  padding: 10px 20px;
  font-size: 15px;
  font-family: "AllianzNeo-Bold", sans-serif;
  color: #003781;
}
.formfield input {
  width: stretch;
}
.last input:focus,
.last input:active {
  border: 2px solid #2976e0;
  outline: none;
}
.jogicont {
  display: flex;
  flex-wrap: wrap;
  font-size: 17px;
}
.magyarazat {
  flex-basis: 100%;
  margin-bottom: 15px;
}
.jogicont input {
  flex-basis: 20px;
  transform: scale(1.5);
  margin: 4px 10px 0 0;
}
.jogicont label {
  flex-basis: calc(100% - 40px);
}
.jogicont p {
  margin-block-start: 5px;
  margin-block-end: 5px;
}
.error {
  color: red;
  font-family: "AllianzNeo-Regular", sans-serif;
}
.formfield .error {
  margin-left: 20px;
}
.thankyoupage {
  display: none;
  color: #42475b;
}
.thankyoupage.show {
  display: block;
  max-width: 500px;
  margin: 0 auto;
  text-align: left;
}
.thanktitle {
  margin: 60px 0 20px 0;
}
.thankyoupage .btn {
  margin: 40px auto 0 auto;
}
.thankyoupage .btn a {
  color: #fff;
  text-decoration: none;
}
.thankyoupage .btn a img {
  height: 18px;
}
@media screen and (max-width: 767px) {
  .thankyoupage.show {
    max-width: calc(100vw - 60px);
  }
  .kerdes {
    margin: 20px auto 20px auto;
  }
  .kerdes,
  .title,
  .thanktitle {
    font-size: 24px;
  }
  .kbevezeto {
    margin: 0 auto 10px auto;
  }
  .kbevezeto,
  .kerdes {
    width: 100%;
  }
  .kerdesek {
    width: calc(100vw - 60px);
  }
  .valaszcont {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
    margin-bottom: 20px;
  }
  .valasz:nth-child(1) {
    grid-column: 1/2;
    -ms-grid-column: 1;
    grid-row: 1/2;
    -ms-grid-row: 1;
  }
  .valasz:nth-child(2) {
    grid-column: 1/2;
    -ms-grid-column: 1;
    grid-row: 2/3;
    -ms-grid-row: 2;
  }
  .valasz:nth-child(3) {
    grid-column: 1/2;
    -ms-grid-column: 2;
    grid-row: 3/4;
    -ms-grid-row: 3;
  }
  .valasz:nth-child(4) {
    grid-column: 1/2;
    -ms-grid-column: 2;
    grid-row: 4/5;
    -ms-grid-row: 4;
  }
  .last {
    width: calc(100% - 200px);
    grid-template-columns: 1fr;
  }
  .formfield {
    width: 100%;
  }
  .urlaphead,
  .magyarazat,
  .jogicont,
  #submission,
  .formfield,
  .last div:nth-child(2) {
    grid-column: 1/2;
  }
  .jogicont {
    color: #000;
    font-family: "AllianzNeo-Bold", sans-serif;
  }
  .jogicont a {
    color: #000;
  }
  #submission {
    margin-bottom: 200px;
  }
}
@media screen and (max-width: 550px) {
  .valaszcont {
    width: calc(100% - 40px);
    margin: 0 0 20px auto;
  }
  .kerdes {
    font-size: 22px;
  }
  .last {
    width: calc(100% - 95px);
  }
}
</style>
